import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const CopyAuditForm = forwardRef(({audit, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  const handleSave = useCallback(({from, questions}) => {
    return services.audit.copyAudit(audit, from, questions);
  }, [services, audit]);

  return (
    <BaseForm
      ref={formRef}
      entity={audit}
      type="audit"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={handleSave}
      onSaved={onSaved}
    />
  );
});

export default CopyAuditForm;
